import React, { ReactElement } from 'react'
import { NavItem } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { NavLinkData } from '@mindfulchefuk/features/Navigation/interfaces'
import { useSignedOutNavMobileContext } from '@mindfulchefuk/features/Navigation/components/Header/SignedOutNav/context/SignedOutNavMobileContext'
import { Box } from '@mindfulchefuk/design-system'
import { SignedOutNavMobileSubItems } from '../SignedOutNavMobileSubItems/SignedOutNavMobileSubItems'

type TSignedOutNavMobileItems = {
  link: NavLinkData
}

export const SignedOutNavMobileItems = ({
  link,
}: TSignedOutNavMobileItems): ReactElement => {
  const { activeItem, setActiveItem } = useSignedOutNavMobileContext()

  const isActive = activeItem === link.id

  const { id, icon, label } = link
  return (
    <Box key={id}>
      <NavItem
        key={id}
        hasSubMenu
        icon={icon}
        id={id}
        active={isActive}
        onClick={() => setActiveItem(isActive ? null : id)}
      >
        {label}
      </NavItem>
      {isActive && (
        <Box display="block" listStyleType="none">
          {link.subNav.map((sublink) => (
            <SignedOutNavMobileSubItems sublink={sublink} />
          ))}
        </Box>
      )}
    </Box>
  )
}
